<template>
  <div class="page">
    <div class="bg-content padding15 m-b-24">
      <el-form size="small" label-width="100px">
        <!-- 第一行 -->
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="公司名称" v-if="this.$partB()">
              <el-select v-model="companyId" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option v-for="item in companyRes" :key="item.id" :label="item.companyName" :value="item.id" :title="item.companyName"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="案件批次号">
              <batch-selector v-model="batchId" :batchNo="batchNoDefault" :testing="false"></batch-selector>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="导入时间">
              <el-date-picker v-model="searchReq.importStartTime" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="至">
              <el-date-picker v-model="searchReq.importEndTime" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="padding15-tb text right">
        <el-button @click="searchReq.page = 1;replyList()" type="primary" size="mini" plain> <i class="fa fa-search"></i> 搜索</el-button>
        <el-button @click="reset" size="mini">重置</el-button>
      </div>
    </div>
    <div class="index-section m-t-24">
      <div class="panel">
        <div class="panel-content">
          <el-table
            ref="singleTable"
            :data="batchRes.list"
            v-loading="loading"
            size="small"
            @row-click="toCaseList"
            highlight-current-row
            style="width: 100%">
            <el-table-column
                property="batchNo"
                fixed
                width="160px"
                align="center"
                label="批次号">
              </el-table-column>
              <el-table-column
                property="groupName"
                fixed
                width="100px"
                align="center"
                label="策略组">
              </el-table-column>
              <el-table-column
                property="caseCount"
                width="70px"
                align="center"
                label="案件总数">
              </el-table-column>
               <el-table-column
                property="collingCount"
                width="100px"
                align="center"
                label="作业中案件数">
              </el-table-column>
              <el-table-column
                property="colledCountStr"
                align="center"
                label="作业完成案件数">
              </el-table-column>
              <el-table-column
                property="confirmedPaymentCountStr"
                align="center"
                label="核实还款">
              </el-table-column>
              <el-table-column
                property="contactCount"
                align="center"
                width="70px"
                label="联系人数">
              </el-table-column>
              <el-table-column
                property="sendCount"
                align="center"
                width="70px"
                label="已发送">
              </el-table-column>
              <el-table-column
                property="noSendCount"
                align="center"
                width="70px"
                label="未发送">
              </el-table-column>
              <el-table-column
                property="responseCountStr"
                align="center"
                label="回复数">
              </el-table-column>
              <el-table-column
                property="answerCountStr"
                align="center"
                label="接听数">
              </el-table-column>
              <el-table-column
                property="responseAndAnsweredCountStr"
                align="center"
                min-width="100px"
                label="接听+回复数">
              </el-table-column>
              <el-table-column
                property="willingPayCountStr"
                align="center"
                label="有还款意向">
              </el-table-column>
              <el-table-column
                property="manProcessingCountStr"
                align="center"
                label="待人工处理">
              </el-table-column>
              <el-table-column
                property="effectiveCountStr"
                align="center"
                label="有效联系">
              </el-table-column>

              <el-table-column
                property="msgFailedCountStr"
                align="center"
                label="短信失败数">
              </el-table-column>
              <el-table-column
                property="ivrFailedCountStr"
                align="center"
                label="语音失败数">
              </el-table-column>
              <el-table-column
                property="msgAndIvrFailedCountStr"
                align="center"
                min-width="120px"
                label="短信+语音失败数">
              </el-table-column>
              <el-table-column
                property="importTime"
                align="center"
                min-width="100px"
                label="导入时间">
              </el-table-column>
              <el-table-column
                label="批次报告"
                align="center">
                <template slot-scope="scope">
                  <i class="fa fa-list" v-on:click="tobatchReport(scope.row)" style="cursor:pointer"></i>
                </template>
              </el-table-column>
          </el-table>
          <div class="text center margin15-tb">
            <el-pagination
              background
              layout="prev, pager, next, sizes, total"
              :page-sizes="[10, 20, 50]"
              :total="batchRes.totalRecords"
              :page-size="searchReq.limit"
              :current-page="searchReq.page"
              @current-change="currentChange"
              @size-change="sizeChange">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BatchSelector from '../../../components/bussiness-select/BatchSelector';

export default {
  inject: ['reload'],
  data() {
    return {
      loading: false,
      companyRes: [],
      companyId: [],
      batchId: [],
      searchReq: {
        page: 1,
        limit: 10,
        // 搜索条件
        companyId: null,
        batchNo: null,
        importStartTime: null,
        importEndTime: null
      },
      batchRes: { 'totalRecords': 0, list: [] },
      batchNoDefault: [],
      certificate: null
    };
  },
  mounted() {
    this.getTime().then(() => {
      this.replyList();
      this.companyList();
    });
  },
  methods: {
    getTime() {
      return new Promise((resolve) => {
        this.$ajax({
          method: 'GET',
          url: '/system/getCurrentTime'
        }).then((res) => {
          this.searchReq.importStartTime = this.formatDate(res.data);
          resolve();
        }).catch(() => {
          this.searchReq.importStartTime = this.formatDate(Date.now());
          resolve();
        });
      });
    },
    formatDate(time) {
      const day = new Date(time);
      const month = String(day.getMonth() + 1).padStart(2, '0');
      const date = String(day.getDate()).padStart(2, '0');
      return `${day.getFullYear()}-${month}-${date} 00:00:00`;
    },
    companyList() {
      this.$ajax({
        method: 'GET',
        url: '/company/list'
      }).then((res) => {
        this.companyRes = res.data;
      });
    },
    replyList() {
      this.loading = true;
      if (this.batchId.join(',')) {
        this.searchReq.batchNo = this.batchId.join(',');
      }
      if (this.companyId.join(',')) {
        this.searchReq.companyId = this.companyId.join(',');
      }
      this.$ajax({
        method: 'POST',
        url: '/overview/batchInfoOfPandect',
        data: this.searchReq
      }).then((res) => {
        this.batchRes.list = res.data.list;
        this.batchRes.totalRecords = res.data.totalRecords;
        this.loading = false;
      });
    },
    currentChange(page) {
      this.searchReq.page = page;
      this.replyList();
    },
    // 显示条数
    sizeChange(num) {
      this.searchReq.limit = num;
      this.replyList();
    },
    reset() {
      this.reload();
    },
    toCaseList(row) {
      this.operateCache([row.batchId], []);
      window.open('/main/case/caseList');
    },
    operateCache(batchNo, caseStatus) {
      const caseSearchBody = {
        page: 1,
        limit: 10,
        order: 'aCaseId',
        sort: 'desc',
        batchNo,
        caseStatus
      };
      localStorage.removeItem('caseSearchCompanyId');
      localStorage.removeItem('caseSearchCache');
      sessionStorage.removeItem('dataReportType');
      localStorage.setItem('caseSearchCompanyId', this.$account().companyId);
      const caseSearchCache = JSON.stringify(caseSearchBody);
      localStorage.setItem('caseSearchCache', caseSearchCache);
      sessionStorage.setItem('dataReportType', 'batchReport');
    }
  },
  components: {
    BatchSelector
  }
};
</script>
<style lang="less" scoped>
  .rate-component {
    span {
      display: inline-block;
      width: 20px;
      vertical-align: middle;
    }
    & > div {
      display: inline-block;
      width: 160px;
      vertical-align: middle;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/main/batchOverview/list.vue